var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Select", {
    attrs: {
      value: _vm.value,
      "label-in-value": "",
      "allow-clear": _vm.allowClear,
      options: _vm.options,
      loading: _vm.loading,
      "show-search": "",
      placeholder: _vm.$t("common.select-text", {
        text: _vm.$t("lbl_internal_contract")
      })
    },
    on: { search: _vm.onSearch, change: _vm.onChange },
    scopedSlots: _vm._u([
      {
        key: "option",
        fn: function(ref) {
          var option = ref.option
          return [_vm._v(" " + _vm._s(option.label) + " ")]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }